module.exports = __webpack_public_path__ + "static/media/service-block-1@2x.a2f8c010.jpg";